//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class TransactionCategoryDisplayItem extends ItemBase {
    Active: boolean = false;
    EventCategory: boolean = false;
    ID: string | null = null;
    Name: string | null = null;

    constructor(initializer?: Partial<TransactionCategoryDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TransactionCategoryDisplayItem";
}
